import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static targets = ["toggle"]
  static values = { url: String }

  toggle() {
    const showCompleted = this.toggleTarget.checked
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content

    // Update session preference
    const preferenceUrl = '/tasks/show-completed'
    fetch(preferenceUrl, {
      method: showCompleted ? 'POST' : 'DELETE',
      headers: {
        'X-CSRF-Token': csrfToken
      }
    }).then(() => {
      // Reload the subtasks list
      const url = new URL(this.urlValue, window.location.origin)

      // Keep existing level parameter if present
      const level = new URLSearchParams(window.location.search).get('level')
      if (level) {
        url.searchParams.set('level', level)
      }

      fetch(url.toString(), {
        method: 'GET',
        headers: {
          'Accept': 'text/vnd.turbo-stream.html'
        }
      })
      .then(response => response.text())
      .then(html => {
        Turbo.renderStreamMessage(html)
        // Also refresh any nested subtask frames that are currently loaded
        this.refreshNestedFrames(showCompleted)
      })
    })
  }

  refreshNestedFrames(showCompleted) {
    // Find all nested subtask frames that are currently loaded
    const nestedFrames = document.querySelectorAll('turbo-frame[id$="-subtasks"][src*="subtasks"]')

    nestedFrames.forEach(frame => {
      const currentSrc = frame.getAttribute('src')
      if (currentSrc) {
        // No need to modify URL params anymore - session will handle it
        frame.setAttribute('src', currentSrc)
        frame.reload()
      }
    })
  }
}